<template>
  <v-container ref="container">
    <TitleParagraphRow :value="value" />

    <CaseStudyList :facet-keys="facetKeys" :value="data" show-all-button />
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { contentProvider } from '#root/renderer/contentProvider'
import { FacetIndexer } from '#root/lib/facet-indexer'
import { FILTER_TYPE_CASE_STUDY } from '#root/lib/consts'
import setWith from 'lodash.setwith'

const FILTERS_VALUE_DEFAULT = {
  courses: [],
  topics: [],
  type: [FILTER_TYPE_CASE_STUDY]
}

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const container = ref(null)
const filtersData = ref(null)
const data = ref(null)
const indexer = ref(null)
const facetCounts = ref(null)
const facetKeys = ref(null)
const facetQuery = computed(() => {
  const query = {}

  if (filtersData.value) {
    if (filtersData.value.type)
      setWith(query, `Type.${filtersData.value.type}`, true, Object)
  }

  return query
})

async function fetchData() {
  data.value = await contentProvider.findOne('resources', '', true)

  if (data.value) {
    indexer.value = new FacetIndexer(data.value.indexer)
    indexer.value.facets.Type.all = indexer.value.allKeys
  }
}

onMounted(async () => {
  watch(facetQuery, newValue => {
    if (indexer.value) {
      const result = indexer.value.query(newValue)
      facetCounts.value = result.counts()
      facetKeys.value = result.keys()
    }
  })

  await fetchData()

  filtersData.value = Object.assign({}, FILTERS_VALUE_DEFAULT)
})
</script>
